import axios from 'axios';
import _ from 'lodash';

export const GET_MODULE_PAYLOAD = 'GET_MODULE_PAYLOAD';
export const FETCH_MODULE = 'FETCH_MODULE';
export const FETCH_FALLBACK_LANGUAGES = 'FETCH_FALLBACK_LANGUAGES';

export const fetch = (url, subType, req = null) => async (dispatch) => {
  try {
    const response = await axios.post(url, req);
    const res = await response.data;
    if (!res.error) {
      dispatch({
        type: FETCH_MODULE,
        moduleKey: req.moduleBridgeHex,
        subType,
        payload: res,
      });
      // dispatch({ type:  FETCH_FALLBACK_LANGUAGES, payload: _.map(res, 'slug') });
      dispatch({ type: FETCH_FALLBACK_LANGUAGES, payload: _.map(res, 'slug') });
    }
  } catch (err) {
    throw new Error(err?.response?.data?.message);
  }
};

export const getModulePayload = (url, req = null) => async (dispatch) => {
  try {
    const response = await axios.post(url, req);
    const res = await response.data;
    if (!res.error) {
      dispatch({
        type: GET_MODULE_PAYLOAD,
        moduleKey: req,
        payload: res,
      });
    }
  } catch (err) {
    throw new Error(err?.response?.data?.message);
  }
};
